import { useState, useEffect, useContext } from "react";
import { MaterialContext } from "../../context/MaterialContext";
import swatchStyle from "../../styles/swatch.module.scss";

function PreviewSwatch({ images, vendor, slug, materialDescription }) {
  const { ROOT_SERVER } = useContext(MaterialContext);
  const [viewing, setViewing] = useState("");
  const [imageNumber, setImageNumber] = useState(0);
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    if (!Array.isArray(images) || images.length === 0) {
      setViewing("");
      setImageLoaded(false);
      return;
    }

    const safeIndex = imageNumber >= images.length ? 0 : imageNumber;
    if (safeIndex !== imageNumber) {
      setImageNumber(safeIndex);
      return;
    }

    setImageLoaded(false);
    setViewing(`${ROOT_SERVER}${vendor}/${slug}/swatch/${images[safeIndex]}`);
  }, [imageNumber, images, ROOT_SERVER, slug, vendor]);

  const handleChangeImage = (i) => {
    setImageLoaded(false);
    setImageNumber(i);
  };

  const handleImageLoaded = () => {
    setImageLoaded(true);
  };

  return (
    <div className={swatchStyle.swatch}>
      {viewing ? (
        <img
          className={
            imageLoaded
              ? `${swatchStyle.imageBlur} ${swatchStyle.loaded}`
              : `${swatchStyle.imageBlur}`
          }
          src={viewing}
          alt={slug}
          onLoad={handleImageLoaded}
          onError={handleImageLoaded}
          ref={(image) => {
            if (image?.complete && image.naturalWidth > 0) {
              handleImageLoaded();
            }
          }}
        />
      ) : null}
      <div className={swatchStyle.vendor}>
        <p>{vendor}</p>
      </div>

      {images?.length >= 2 && (
        <div className={swatchStyle.imageSelector}>
          {images?.map((image, i) => (
            <span
              key={image}
              onClick={() => handleChangeImage(i)}
              style={
                imageNumber === i
                  ? { background: "transparent" }
                  : { background: "#FEFEFE90" }
              }
            />
          ))}
        </div>
      )}
      <div className={swatchStyle.information}>
        {!imageLoaded && <div className={swatchStyle.loadingBar} />}
        <h3>{slug.toUpperCase().replaceAll("-", " ")}</h3>
        <h4>{materialDescription}</h4>
      </div>
    </div>
  );
}

export default PreviewSwatch;
